import React from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from '@wbk/ui';

interface FileInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  containerClassName?: string;
  fileName?: string;
}

export function FileInput(props: FileInputProps) {
  const { t } = useTranslation('common');
  const ref = React.useRef<HTMLInputElement>(null);

  const handleClick = () => {
    ref.current?.click();
  };

  return (
    <>
      <input {...props} type='file' hidden ref={ref} />

      <button
        type='button'
        onClick={handleClick}
        className='flex w-full items-center justify-start gap-2 rounded-md border border-dashed border-white/20 bg-white/10 p-2 px-2'
      >
        <Typography
          as='span'
          variant='body-XS'
          className='shrink-0 rounded-full border border-white px-2 py-1 text-sm text-white'
        >
          {props?.fileName
            ? t('sponsor_form.file_upload.select_another')
            : t('sponsor_form.file_upload.upload_file')}
        </Typography>
        <Typography as='span' variant='body-S' className='line-clamp-1 text-[#71717A]'>
          {props.fileName || t('sponsor_form.file_upload.no_file')}
        </Typography>
      </button>
    </>
  );
}
